/**
 * section-cart.js
 * Interactive logic for the GOZO shopping cart page.
 */

(function() {
  function initCartSection() {
    const form = document.getElementById('cart-form');
    if (!form) return;

    const steppers = form.querySelectorAll('.cart-item__stepper');
    steppers.forEach(stepper => {
      const decBtn = stepper.querySelector('.decrement');
      const incBtn = stepper.querySelector('.increment');
      const input = stepper.querySelector('.cart-item__qty-input');

      if (!decBtn || !incBtn || !input) return;

      decBtn.addEventListener('click', function(e) {
        e.preventDefault();
        let val = parseInt(input.value, 10) || 0;
        if (val > 0) {
          input.value = val - 1;
          form.submit();
        }
      });

      incBtn.addEventListener('click', function(e) {
        e.preventDefault();
        let val = parseInt(input.value, 10) || 0;
        input.value = val + 1;
        form.submit();
      });
    });
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartSection);
  } else {
    initCartSection();
  }

  // Theme customizer load hook
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.classList.contains('cart-section') || e.target.querySelector('.cart-section')) {
      initCartSection();
    }
  });
})();
